import { DeleteFilled } from '@ant-design/icons';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import Filters, { registerModuleFilters } from '@/utils/input/filters';

const TypeFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'type',
  label: 'custom.lists.text.type',
  enumNamespace: getEnumNamespace(CoreEnums.CustomListType),
  enumSource: CoreEnums.CustomListType,
  options: createEnumOptions(CoreEnums.CustomListType, 'customList.select'),
};

const GroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'customListGroupId',
  label: 'global.text.group',
  apiRoute: 'customListGroup/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const ProcessFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'processId',
  label: 'global.text.process',
  apiRoute: 'process/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const IsPublicFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  TypeFilter,
  GroupFilter,
  ProcessFilter,
  IsPublicFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('lists', [TypeFilter, GroupFilter, ProcessFilter, IsPublicFilter]);

export const getListOptionsItems = (formatMessage) => [
  {
    key: 'delete',
    label: formatMessage({ id: 'global.text.delete' }),
    icon: <DeleteFilled />,
    danger: true,
  },
];
